import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import { ReactComponent as CloseIcon } from "../../svgs/close.svg";

interface ModalProps {
  title?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  open: boolean;
  handleClose: () => void;
  content?: React.ReactNode;
}

const CustomModal: React.FC<ModalProps> = ({
  open,
  maxWidth,
  handleClose,
  content,
  title,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth ? maxWidth : "md"}
      fullWidth
    >
      <DialogTitle
        sx={{
          paddingInline: { xs: "1rem", sm: "3rem", lg: "5rem" },
          marginBlockStart: "0.8rem",
          marginBlockEnd: "2rem",
          fontSize: "30px",
        }}
      >
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <p>{title}</p>

          <IconButton
            onClick={handleClose}
            sx={{
              backgroundColor: "#F0F0F0",
              borderRadius: "5px",
              padding: "2px"
            }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          background:
            "linear-gradient(180deg, var(--color-main-white) 80%, #FDE5E9 100%)",
          paddingInline: { xs: "1rem", sm: "3rem", lg: "5rem" },
        }}
      >
        {content && content}
      </DialogContent>
    </Dialog>
  );
};

export default CustomModal;
